import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Link, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import AppLogo from '../ui/AppLogo';
import { format } from 'date-fns';

const styleSheet = theme => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(2),
      overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadRow3: {
      height: 32,
    },
    appnameitem: {
      marginLeft: 8,
    }
});

class VendorTransactionsList extends React.Component {
 
  goTo(route) {
    console.log(this.props);
    this.props.history.push(`/${route}`);
  }

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.tl.nodes;

    // Get the summary data from the last entry
    let bcChargeSum = 0;
    let rebateSum = 0;
    let lastIdx = thenodes.length-1;
    if (lastIdx >= 0)
    {
      let lastNode = thenodes[lastIdx];
      bcChargeSum = lastNode.bcChargeSum;
      rebateSum = lastNode.rebateSum;
    }

    let bcChargeSummary = Number(bcChargeSum)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    let rebateSummary = Number(rebateSum)
      .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
 
    let keyCounter = 1;
    return (
      <div className={classes.paper}>
        <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow className={classes.tblHeadRow}>
                <TableCell className={classes.tblHeadCell} colSpan={3}/>
                <TableCell align="right">Total&nbsp;charges</TableCell>
                <TableCell align="right" colSpan={2}>Total&nbsp;commissions</TableCell>
              </TableRow>
              <TableRow className={classes.tblHeadRow3}>
                <TableCell>Date</TableCell>
                <TableCell>App</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell align="right"><Typography variant="subtitle2" >{bcChargeSummary}</Typography></TableCell>
                <TableCell  align="right" colSpan={2}><Typography variant="subtitle2">{rebateSummary}</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { thenodes.map(n => {
                let tdate = format(new Date(n.transactionTime), 'yyyy-MM-dd');
                let bcc = Number(n.bindCardCharge)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                let rebate = Number(n.rebate)
                          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                let hasCommission = false;
                let theProgramLink = '';
                let thePayoutLink = '';
                if (n.programName) {
                  hasCommission = true;
                  theProgramLink = 'resellerprogramedit?resellerPId=' + n.resellerPId + '&accountId=' + this.props.resellerAccountId  + "&fp=Transactions"
                  thePayoutLink = 'payoutdetail?vendorPayoutId=' + n.vendorPayoutId  + "&fp=Transactions";
                }
                let theKey = n.customerAppId + '-' + n.transactionTime  + '-' + keyCounter++;
                return (
                  <TableRow key={theKey}>
                    <TableCell style={{whiteSpace: 'nowrap'}}>{tdate}</TableCell>
                    <TableCell>
                      <Grid container alignItems="center">
                        <Grid item>
                          <AppLogo logoPath={n.appLogo} appName={n.appName} imageHeight='24px'/>                          
                        </Grid>
                        <Grid item className={classes.appnameitem}>
                          <Typography variant="subtitle2">{n.appName}</Typography>
                        </Grid>
                      </Grid>
                    </TableCell>
                    <TableCell align="left">{n.customerAccountName}</TableCell>
                      <TableCell align="right">{bcc}</TableCell>
                      <TableCell align="left">
                        {hasCommission &&
                        <Typography variant="body2">
                          
                            <Link component="button"  variant="body2" className={classes.custlink} onClick={this.goTo.bind(this, theProgramLink)}>
                                {n.programName}
                            </Link>
                          
                        </Typography>
                        }
                      </TableCell>
                      <TableCell align="right">
                        {hasCommission &&
                        <Typography variant="body2">
                          
                            <Link component="button"  variant="body2" className={classes.custlink} onClick={this.goTo.bind(this, thePayoutLink)}>
                                {rebate}
                            </Link>
                          
                        </Typography>
                        }
                        {!hasCommission &&
                        <div>
                        {rebate}
                        </div>
                        }
                        </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
 
  } // end render()
}

VendorTransactionsList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(VendorTransactionsList), { tl: graphql`
  fragment VendorTransactionsList_tl on VendorResellerBindCardChargeWSum2SConnection {
    nodes {
      bcChargeSum
      rebateSum
      customerAccountId
      customerAccountName
      customerAppId
      customerAppStatus
      provisioningAccountId
      appId
      appName
      appLogo
      transactionId
      transactionTime
      bindCardCharge
      rebate
      programName
      resellerPId
      vendorPayoutChargeId
      vendorPayoutId
    }
  }
`});
